import type { GridTableContentSection } from 'components/GridTable/types'
import type { StackedChartSection } from 'components/StackedChart/types'
import { translate } from 'i18n/i18n'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'

export const propertyLacksDataSectionMaker = ({
  id,
  propertyId = Number(selectedFieldAssetsStore.getState().property),
  title,
  titleToggle,
  titleLink,
  fieldAssetPicker,
}: {
  id: StackedChartSection['id'] & GridTableContentSection['id']
  propertyId?: number
  title: StackedChartSection['title'] & GridTableContentSection['title']
  titleToggle?: StackedChartSection['titleToggle'] & GridTableContentSection['titleToggle']
  titleLink?: StackedChartSection['titleLink'] & GridTableContentSection['titleLink']
  fieldAssetPicker: StackedChartSection['fieldAssetPicker'] & GridTableContentSection['fieldAssetPicker']
}): StackedChartSection & GridTableContentSection => {
  const propertyName =
    fieldAssetStore.getState()?.properties?.[propertyId]?.propertyName ??
    translate.phrases.banyanApp('Unknown Property')

  return {
    id,
    title,
    titleToggle,
    titleLink,
    fieldAssetPicker,
    items: [],
    fullWidthItems: [
      {
        height: 150,
        content: (
          <div
            css={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              textAlign: 'center',
            }}
          >
            {translate.phrases.banyanApp('No data available for this property {{propertyName}}', {
              propertyName,
            })}
          </div>
        ),
      },
    ],
    defaultCollapsed: true,
  }
}
